import React from 'react';
import PropTypes from 'prop-types';
import {css} from 'aphrodite';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

/**
 * ToolTipCell is used to display a tooltip when hoving the mouse over the `placeholder`.
 *
 * props parameters:
 * @param {object|string} placeholder html fragment or text to hover over to display tooltip.
 * @param {string}        text        text to display in the tooltip.
 * @param {string}        id          id property for the tooltip.
 * @param {string}        placement   where to place the tooltip, 'top', 'bottom', 'right' or 'left'.
 * @param {object}        styleSheet  (Optional) If provided, must contain tooltip attribute, which contains the css for the tooltip.
 *
 * @returns ToolTipCell component
 */
export const ToolTipCell = ({
  placeholder,
  text,
  id,
  placement = 'top',
  styleSheet,
  ariaLabel,
}) =>  {
  if (!text) {
    return (<span>{placeholder}</span>);
  }

  const tooltip = <Tooltip id={id} className={styleSheet ? css(styleSheet.tooltip) : ''}>{text}</Tooltip>;

  return (
    <OverlayTrigger
      overlay={tooltip}
      placement={placement}
      delay={{show: 150, hide: 150}}
    >
      <span role="button" tabIndex={0} aria-label={ariaLabel || text} aria-describedby={id}>{placeholder}</span>
    </OverlayTrigger>
  );
}

ToolTipCell.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  placeholder: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  placement: PropTypes.oneOfType([
    PropTypes.string,
  ]),
  styleSheet: PropTypes.object,
  ariaLabel: PropTypes.string,
};

export default ToolTipCell;
